import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Plan', numeric: false, disablePadding: false, label: 'Plan', show:true, fixed:false, width:250, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'PlanComercial', numeric: false, disablePadding: false, label: 'Nombre Plan', show:true, fixed:false, width:250, num:1, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Subida', numeric: false, disablePadding: false, label: 'Subida', show:true, fixed:false, width:150, num:2, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Bajada', numeric: false, disablePadding: false, label: 'Bajada', show:true, fixed:false, width:150, num:3, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Valor', numeric: false, disablePadding: false, label: 'Valor', show:true, fixed:false, width:150, num:4, align:'left', fontSize:'16px', bolder:false, type:'text' }, 
        { id: 'Garantia', numeric: false, disablePadding: false, label: 'Garantia', show:true, fixed:false, width:150, num:5, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Prioridad', numeric: false, disablePadding: false, label: 'Prioridad', show:true, fixed:false, width:150, num:6, align:'left', fontSize:'16px', bolder:false, type:'number' },   
        { id: 'QueueTypeUpload', numeric: false, disablePadding: false, label: 'Queue Type Upload', show:true, fixed:false, width:180, num:7, align:'left', fontSize:'16px', bolder:false, type:'text' },   
        { id: 'QueueTypeDownload', numeric: false, disablePadding: false, label: 'Queue Type Download', show:true, fixed:false, width:180, num:8, align:'left', fontSize:'16px', bolder:false, type:'text' },   
    ];

    const variablesObject = {
        api:'/api/Planes',
        apiMultiples:'/api/Planes/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,
        label:'PLAN',
        nameLocalStorage:'headersPlanesYounet',
        order:'asc',
        orderBy:'Plan',
        rowsPerPage:15,
        sumWidth:'100%',
        title:'PLANES',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
        inputTrim:true
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;